import axios from "../plugins/parseAxios";

export class TransactionCategoryApi {
  static createTransactionCategory(formData) {
    return axios.post("functions/createTransactionCategory", formData);
  }
  static getTransactionCategoryByProject(formData) {
    return axios.post("functions/getTransactionCategoryByProject", formData);
  }
  static removeTransactionCategory(id) {
    return axios.post("functions/removeTransactionCategory", { id });
  }
  static updateTransactionCategory(formData) {
    return axios.post("functions/updateTransactionCategory", formData);
  }
}